// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","error":"NotFound_error__nclvK","title":"NotFound_title__OQ-MU","text":"NotFound_text__0q9lj"};